import api from "./api";
import { UsersResponse, RolesResponse } from "../../types/users";

export const getAllUsers = async (page: number, pageSize: number, search?: string, filter?: string): Promise<UsersResponse> => {
  const params = {
    ...(page ? { pageNumber: page } : {}),
    ...(pageSize ? { pageSize } : {}),
    ...(search ? { search } : {}),
    ...(filter ? { filter } : {}),
  };
  const response = await api.get("/User/GetAllUsers", { params });
  return response.data;
};

export const getRoles = async (): Promise<RolesResponse> => {
  const response = await api.get("/User/GetRoles");
  return response.data;
};

export const addUser = async (userData: FormData): Promise<any> => {
  const response = await api.post("/User/AddUser", userData, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
  return response.data;
};

export const getUserById = async (id: string): Promise<any> => {
  const response = await api.get(`/User/GetUserById?id=${id}`);
  return response.data;
};

export const updateUser = async (userData: FormData): Promise<any> => {
  const response = await api.put("/User/UpdateUser", userData, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
  return response.data;
};

export const deleteUser = async (id: string): Promise<any> => {
  const response = await api.delete(`/User/DeleteUser?id=${id}`);
  return response.data;
};